import { render, staticRenderFns } from "./officePreview.vue?vue&type=template&id=12687802&scoped=true"
import script from "./officePreview.vue?vue&type=script&lang=js"
export * from "./officePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12687802",
  null
  
)

export default component.exports